import { FwdRollMutableRowModel } from "app/bfx-blotter-intervention/fwd-roll-pricing/models/FwdRollMutableRowModel";
import { FwdRollPortfolioModel } from "app/bfx-blotter-intervention/fwd-roll-pricing/models/FwdRollPortfolioModel";
import {
  BigNumber,
  FwdRollDealtPairNetPricingImpl,
  FwdRollRowType,
  Tenor,
} from "shared/cubiq-model-multi-asset";

export class FwdRollDealtPairModel
  extends FwdRollDealtPairNetPricingImpl
  implements FwdRollMutableRowModel
{
  ptsPrecision: number;

  ptsMultiplier: BigNumber;

  minPrecision: number;

  /* For Change detection */
  primedMarketForwardPts: BigNumber;
  primedClientForwardPts: BigNumber;
  primedFwdMarkup: BigNumber;

  public isMarketPtsChanged: boolean;
  public isClientPtsChanged: boolean;
  public isFwdMarkupChanged: boolean;
  public isEditorDisabled: boolean = false;

  constructor(private portfolioModel: FwdRollPortfolioModel) {
    super();
  }

  public get rowType() {
    return FwdRollRowType.DEALT;
  }

  /**
   * Can this row be edited?
   */
  public get isEditable(): boolean {
    const canEdit =
      !this.portfolioModel.disabled && !this.spotAggregateFg && this.settleTenor !== Tenor.SPOT;
    return canEdit;
  }

  /**
   * Can this row markup be edited?
   */
  public get isMarkupEditable(): boolean {
    return true;
  }

  /**
   * Does this model support blotter selection? Should be fault for all currency rows,
   * spot aggregate rows or Spot tenor rows
   */
  public get supportsSelection(): boolean {
    const supportsSelection =
      !this.portfolioModel.disabled && !this.spotAggregateFg && this.settleTenor !== Tenor.SPOT;
    return supportsSelection;
  }

  public get isChanged(): boolean {
    return this.isMarketPtsChanged || this.isClientPtsChanged || this.isFwdMarkupChanged;
  }

  public get marketForwardPtsScaled(): BigNumber {
    return this.marketForwardPts?.div(this.ptsMultiplier);
  }

  public get clientForwardPtsScaled(): BigNumber {
    return this.clientForwardPts?.div(this.ptsMultiplier);
  }

  public get forwardMarkupScaled(): BigNumber {
    return this.fwdMarkup?.div(this.ptsMultiplier);
  }

  public get reqForwardPtsScaled(): BigNumber {
    return this.reqForwardPts?.div(this.ptsMultiplier);
  }

  public updateMarketForwardPts(value: BigNumber): boolean {
    return this.portfolioModel.updateMarketForwardPts(this, value);
  }

  updateClientForwardPts(value: BigNumber): boolean {
    return this.portfolioModel.updateClientForwardPts(this, value);
  }

  updateForwardMarkup(value: BigNumber): boolean {
    return this.portfolioModel.updateForwardMarkup(this, value);
  }

  public get intent() {
    return this.netIntent;
  }

  recalcCounterAmount(): string {
    this.netCounterAmt = this.netFixedAmt.times(this.clientForwardRate);
    return "netCounterAmt";
  }

  /**
   * Get this value from the isLocked prooperty on the base class
   */
  public get lockedForUserPricing(): boolean {
    return this.isLocked;
  }

  public set lockedForUserPricing(value: boolean) {
    this.isLocked = value;
  }
}
